import { FaqVariants, TexpandedState } from './index';

export const getExpandedState = (
  expanded: TexpandedState,
  index: number
): boolean => {
  switch (expanded) {
    case 'firstOnly':
      return index === 0;
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return true;
  }
};

export const getVariantClasses = (
  variant: keyof typeof FaqVariants
): string => {
  const classes: Record<keyof typeof FaqVariants, string> = {
    default:
      'border-sm border-grey-300 px-8 text-s-20 mt-4 rounded-lg sm:border-x-0 sm:rounded-none sm:px-2 sm:border-dashed sm:mt-0 sm:border-t-0',
    partner:
      'border-t-sm border-grey-300 border-opacity-50 sm:border-opacity-100 pr-8 text-s-20 sm:border-b-sm sm:border-x-0 sm:rounded-none sm:px-2 sm:mt-0 border-t-0',
    calculator:
      'border-t-sm border-grey-300 border-opacity-50 sm:border-opacity-100 pr-8 text-s-20 sm:border-b-sm sm:border-x-0 sm:rounded-none sm:px-2 sm:mt-0 border-t-0',
    itrGuide:
      'border-b border-b-[#F4F4F5] text-s-20 sm:border-b-sm sm:border-x-0 sm:rounded-none sm:px-2 sm:mt-0',
  };

  return classes[variant];
};

export const getVariantClassesHeader = (
  variant: keyof typeof FaqVariants
): string => {
  const classes: Record<keyof typeof FaqVariants, string> = {
    default: 'py-8 sm:my-auto sm:text-base sm:font-medium',
    partner: 'py-5 text-s-20 sm:my-auto sm:text-s-20 sm:font-medium sm:py-6',
    calculator:
      'py-5 px-6 text-base font-semibold m-0 sm:my-auto sm:font-medium sm:py-6',
    itrGuide:
      'guideFaqHeader p-6 text-base text-grey-800 font-medium m-0 sm:my-auto sm:font-medium sm:py-6',
  };

  return classes[variant];
};

export const getVariantClassesDetail = (
  variant: keyof typeof FaqVariants
): string => {
  const classes: Record<keyof typeof FaqVariants, string> = {
    default: 'overflow-x-hidden text-base pb-5 sm:py-5 mt-[-18px]',
    partner:
      'partnerFAQ overflow-x-hidden text-base pb-5 sm:py-5 sm:pt-0 mt-[-18px]',
    calculator: 'partnerFAQ overflow-x-hidden text-base sm:py-5 sm:pt-0',
    itrGuide:
      'guideFaqBody px-6 py-1 overflow-x-hidden text-base pb-5 sm:py-5 sm:pt-0 mt-[-18px]',
  };

  return classes[variant];
};
